import { RoutesInterface } from '@g17eco/types/routes';

export const emissionsCalculatorsRoutes: RoutesInterface = {
  EMISSIONS_CALCULATORS: {
    id: 'emissions_calculators',
    label: 'Emissions: Carbon Calculators',
    path: '/emissions-calculator',
    exact: true,
    icon: 'fa-calculator',
    auth: true,
  },
  SIMPLE_CARBON_CALCULATOR: {
    id: 'simple_emissions_calculators',
    label: 'Simple Emissions Calculator',
    path: '/emissions-calculator/simple',
    exact: true,
    icon: 'fa-calculator',
    auth: true,
  },
};
